/** 프로 피드백 신청 옵션 번호 → 표시 라벨 (expert-feedback/page.tsx 기준) */
export const FEEDBACK_OPTION_LABELS: Record<number, string> = {
  1: "PDF 리포트",
  2: "음성 피드백",
  3: "실시간 1:1 피드백",
};

export function getFeedbackOptionLabel(
  option?: number | string | null
): string {
  if (option == null || option === "") return "옵션 정보 없음";

  if (typeof option === "number") {
    return FEEDBACK_OPTION_LABELS[option] ?? `옵션 ${option}`;
  }

  const trimmed = option.trim();
  if (trimmed === "text") return "PDF 리포트";
  if (trimmed === "video") return "실시간 1:1 피드백";
  if (trimmed === "text_video") return "PDF + 영상";
  if (trimmed.includes("실시간")) return "실시간 1:1 피드백";
  if (trimmed.includes("영상 피드백") || trimmed.includes("영상")) {
    return "실시간 1:1 피드백";
  }
  if (trimmed.includes("음성")) return "음성 피드백";
  if (trimmed.includes("PDF")) return "PDF 리포트";

  const parsed = Number(trimmed);
  if (!Number.isNaN(parsed)) {
    return FEEDBACK_OPTION_LABELS[parsed] ?? trimmed;
  }

  return trimmed;
}
